import React, { FC } from 'react';
import { Loaders } from '../index';

/**
 * Special loader for startup (cognito lookup) and initial queries
 * (getByUserFeed) before fixed header is rendered. The calc offset
 * prevents page jumping.
 */
const StandardNoHeader: FC = () => (
  <div style={{ height: 'calc(100% - 80px)' }}>
    <Loaders.Standard />
  </div>
);

export default StandardNoHeader;
